import { render, staticRenderFns } from "./MatchTest.vue?vue&type=template&id=f62a91f4&scoped=true&"
import script from "./MatchTest.vue?vue&type=script&lang=js&"
export * from "./MatchTest.vue?vue&type=script&lang=js&"
import style0 from "./MatchTest.vue?vue&type=style&index=0&id=f62a91f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62a91f4",
  null
  
)

export default component.exports